import { checkEmailServiceModule } from '../../../services/check-email-service/check-email-service';
import { formGroupMessagesComponentModule } from '../form-group-messages/form-group-messages';

export const uniqueEmailValidatorComponentModule = angular
  .module('Q.components.forms.unique-email-validator', [
    checkEmailServiceModule,
    formGroupMessagesComponentModule,
  ])

  .directive(
    'uniqueEmail',
    function (checkEmailService, $q, $timeout, FORM_GROUP_MESSAGES) {
      const DEBOUNCE_RATE = 1000;

      FORM_GROUP_MESSAGES.add(
        'uniqueEmail',
        'That email has already been used to sign up.',
      );

      return {
        require: 'ngModel',
        link(scope, el, attrs, ngModel) {
          // tracks whether we have a delayed check in progress
          let activeTimer = null;
          // tracks number of active checks heading to the server
          let activeRequests = 0;

          ngModel.$asyncValidators.uniqueEmail = (modelValue) => {
            // no value
            if (!modelValue) return $q.when(true);

            // disabled
            if (attrs.uniqueEmail && !scope.$eval(attrs.uniqueEmail))
              return $q.when(true);

            // We just cancel any timer still running
            if (activeTimer) {
              $timeout.cancel(activeTimer);
            }

            // if we already have an active request, debounce!
            if (activeRequests) {
              // NOTE: Do NOT combine these statements.
              // We can only cancel a timer if it's the original promise returned from $timeout!
              activeTimer = $timeout(angular.noop, DEBOUNCE_RATE);

              return activeTimer.then(() => (activeTimer = null)).then(check);
            } else {
              return check();
            }

            function check() {
              activeRequests++;
              return checkEmailService
                .check(modelValue, attrs.uniqueEmailModel)
                .then((data) => {
                  activeRequests--;
                  if (!data.exists) {
                    ngModel.flagInvalid = !!data.invalid;
                    ngModel.flagJunk = !!data.junk;
                    ngModel.flagGeneric = !!(data.generic || data.junk);
                    return true;
                  } else {
                    return $q.reject();
                  }
                });
            }
          };
        },
      };
    },
  );
